// @flow
/**
 * Familias que aparecen en la home
 */
export const HOME_FAMILIES = [
  {
    id: 'fund',
    name: 'Fondos de inversión',
    tag: {
      id: '4425',
      alias: 'fondos-de-inversion',
      name: 'Fondos de inversión'
    }
  },
  {
    id: 'etf',
    name: 'ETFs',
    tag: {
      id: '15133',
      alias: 'etfs',
      name: 'ETFs'
    }
  }
];

// Tag de las gestoras del bloque «Nuestros grupos» (GroupsBlock)
export const HOME_MANAGERS_TAG = { id: '34488', alias: 'home-managers' };

// Cuántos productos de cada familia pinta la home (ProductsBlock), y los que se piden
export const HOME_PRODUCTS_QTY = 5;

// Cuántos vídeos y podcasts pinta la home (MultimediaGrid) y mete en su schema, y los que se piden
export const HOME_MEDIA_QTY = 4;

// Los bloques de artículos de la home que edita el dashboard (Contenidos → Highlights → Novedades y
// Eventos), en el orden en que se pintan. Son secciones de la tabla de highlights: cada uno llega
// con sus artículos, en el orden de los huecos, y con su bloque (título y enlace del pie). Sin
// huecos, el bloque no se pinta.
export const HOME_HIGHLIGHT_SECTIONS = ['novedades', 'eventos'];
